import React, { useEffect, useState } from "react";

const NavigationBlock = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1320);
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
      setMenuOpen(false); // ✅ Close menu after clicking a link
    }
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const nowMobile = window.innerWidth <= 1320;
      setIsMobile(nowMobile);

      // ✅ If window is resized to desktop, close menu automatically
      if (!nowMobile && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [menuOpen]);

  return (
    <header
      className={`navbar z-30 ${scrolled ? "scrolled" : ""}`}
      style={isMobile ? { padding: 0 } : {}}
    >
      {!isMobile && (
        <div className="main-container-blk">
          <div className="navbar-left">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/icxeed-logo-aws.svg"
              alt="Logo iCXeed"
            />
          </div>
          <nav className="navbar-links">
            <button onClick={() => scrollToSection("icxeed-difference")}>
              iCXeed Difference
            </button>
            <button onClick={() => scrollToSection("clientele-verticals")}>
              Clientele & Verticals
            </button>
            <button onClick={() => scrollToSection("use-cases")}>
              Use Cases / Battlecards
            </button>
            <button onClick={() => scrollToSection("videos-and-demos")}>
              Videos and Demos
            </button>
            <button onClick={() => scrollToSection("client-testimonials")}>
              Testimonials
            </button>
            <button onClick={() => scrollToSection("key-contacts")}>
              Key Contacts
            </button>
            <button onClick={() => scrollToSection("ask-iris")}>
              Ask IRis
            </button>
          </nav>
        </div>
      )}

      {isMobile && (
        <React.Fragment>
          <div className="mobile-navigation-blk">
            <div>
              <img
                src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/icxeed-logo-aws.svg"
                alt="Logo iCXeed"
              />
            </div>
            <div>
              <div
                className={`hamburger-menu ${menuOpen ? "open" : ""}`}
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
          {menuOpen && (
            <div className="mobile-list-blk">
              <ul>
                <li>
                  <button onClick={() => scrollToSection("icxeed-difference")}>
                    iCXeed Difference
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("clientele-verticals")}
                  >
                    Clientele & Verticals
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("use-cases")}>
                    Use Cases / Battlecards
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("videos-and-demos")}>
                    Videos and Demos
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("client-testimonials")}
                  >
                    Testimonials
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("key-contacts")}>
                    Key Contacts
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("ask-iris")}>
                    Ask IRis
                  </button>
                </li>
              </ul>
            </div>
          )}
        </React.Fragment>
      )}
    </header>
  );
};

export default NavigationBlock;
